var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 24.625h8.25a1.376 1.376 0 0 0 1.375-1.375v-2.063h-1.375v2.063h-8.25V6.75h8.25v2.063h1.375V6.75a1.376 1.376 0 0 0-1.375-1.375h-8.25A1.377 1.377 0 0 0 6.75 6.75v16.5a1.377 1.377 0 0 0 1.375 1.375z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.153 18.153 2.465-2.465h-9.743v-1.376h9.743l-2.465-2.465.972-.972L23.25 15l-4.125 4.125-.972-.972z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3145f255942c67aac721fd52bf7bcb14.svg";
export { ForwardRef as ReactComponent };